import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

export const ExclamationIcon = ({ size = defaultScale(50), fontWeight='normal' ,borderWidth=1, fontSize= 25, marginHorizontal=0
 , borderColor = Theme.PRIMARY, color = Theme.PRIMARY }) => (
  <View style={[styles.container, {
    width: size,
    height: size,
    borderRadius: size/2,
    borderWidth,
    marginBottom: defaultScale(marginHorizontal),
    marginTop: defaultScale(marginHorizontal),
    borderColor,
  }]}>
    <Text style={[styles.exclamation, {fontWeight,fontSize, color, lineHeight: fontSize }]}>!</Text>
  </View>
)

const styles = StyleSheet.create({
  container: {
    width: defaultScale(50),
    height: defaultScale(50),
    borderRadius: defaultScale(25),
    borderWidth: 1,
    borderColor: Theme.PRIMARY,
    alignItems: 'center',
    justifyContent: 'center',
  },
  exclamation: {
    ...Theme.textStyle.heading,
    // fontSize: 25,
    // lineHeight: 25,
    color: Theme.PRIMARY,
    // fontFamily: Theme.CustomBold,
  },
});
